import React from "react"
import { withFormsy } from "formsy-react"

/* Import Global Components */
import CheckboxIcon from "~components/icon/normal/checkbox"

/* Import Local Styles */
import "./checkbox.css"

const Checkbox = ({ name, label = "", style = {}, value = "", setValue }) => {
  const handleOnChange = () => {
    if (value) {
      setValue(false)
    } else {
      setValue(true)
    }
  }

  const handleClick = () => {
    if (value) {
      setValue(false)
    } else {
      setValue(true)
    }
  }

  return (
    <label className="checkbox" style={style} htmlFor={name}>
      <span className="input">
        <input
          type="checkbox"
          name={name}
          value={value}
          checked={value}
          onChange={handleOnChange}
        />
        <span className="control">{value ? <CheckboxIcon /> : null}</span>
      </span>
      <button className="label" onClick={handleClick}>
        {label}
      </button>
    </label>
  )
}

export default withFormsy(Checkbox)
